import {
    postsendSNS
} from './api/sendsns'

class SMSService {
    async sendSingleMessage(item){
        var params = {
            message_record: item
        }
        try {
            const result = await postsendSNS(params)
            return result
        } catch (err) {
            return err
        } 
    }

}

export default new SMSService()